import { Injectable } from '@angular/core';
import { SmartHomeComponentsApi } from '@vi-iot/client/apis/smart-home-components/smart-home-components.api';
import { AuthStore, RemoteConfigStore } from '@store';
import { SmartHomeComponentsMockApi } from '@vi-iot/client/apis/smart-home-components/smart-home-components.mock-api';
import { BaseApiPickerImpl } from '../base.api-picker';

@Injectable({ providedIn: 'root' })
export class SmartHomeComponentsApiPicker extends BaseApiPickerImpl<
  SmartHomeComponentsApi | SmartHomeComponentsMockApi
> {
  constructor(
    protected authStore: AuthStore,
    protected realApi: SmartHomeComponentsApi,
    protected mockApi: SmartHomeComponentsMockApi,
    private remoteConfigStore: RemoteConfigStore
  ) {
    super(authStore, realApi, mockApi);
    this.remoteConfigStore.isSmartHomeComponentsUsingMock$.subscribe();
  }

  // override not working with pretier -> TODO
  // override instance(): SmartHomeComponentsApi | SmartHomeComponentsMockApi {
  instance(): SmartHomeComponentsApi | SmartHomeComponentsMockApi {
    if (this.remoteConfigStore.isSmartHomeComponentsUsingMockSync) {
      return this.mockApi;
    }
    return this.authStore.isDemoSync ? this.mockApi : this.realApi;
  }
}
